
let common = {
  install: function(Vue, options){

    Vue.mixin({

    }),

    Vue.prototype.$trim = function(str) {
      return str.replace(/^\s+|\s+$/g, '');
    }
  }
}
export default common;



// WEBPACK FOOTER //
// ./src/js/common.js